import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requireActivePlanOrNoAccounts } from './-guards';

export const Route = createFileRoute('/n/_auth/settings')({
  beforeLoad: requireActivePlanOrNoAccounts,
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
